import React from 'react'
import styled from 'styled-components'
import queryString from 'query-string'
import Header from '../components/Header'
import Passages from '../containers/Passages'
import Loader from '../components/Loader'
import { palette } from '../styles/branding'
import { changeColorMode } from '../helpers/helpers'
import { useMultivertrekken } from '../hooks/useMultivertrekken.hooks'
import GeneralError from '../components/GeneralError'

const Layout = styled.div`
  min-height: 100vh;
  background: ${(props) => (props.light ? palette.neutral1 : '#3b3b3b')};
`

const Multimaxi = () => {
  const { passages, error, isLoading } = useMultivertrekken()

  if (!passages.lijnen.length && error) {
    return <GeneralError />
  }

  if (isLoading) {
    return <Loader />
  }

  const queryParam = queryString.parse(window.location.search)
  const lightMode = changeColorMode(queryParam.inverse)

  return (
    <Layout light={lightMode}>
      <Header
        error={!!error}
        currentTime={passages.serverTijd}
        hasLines={passages.lijnen.length > 0}
      />
      <Passages
        error={!!error}
        currentTime={passages.serverTijd}
        lines={passages.lijnen}
      />
    </Layout>
  )
}

Multimaxi.propTypes = {}
Multimaxi.defaultProps = {}

export default Multimaxi
